import React from "react";
import { Grid, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { StateItem } from "../../types/paymentTypes";

type StateAutocompleteProps = {
  label: string;
  selectedStateCode: string;
  handleStateChange: (e: any, value: any) => void;
  disabled: boolean;
  options: StateItem[];
};

const StateAutocomplete: React.FC<StateAutocompleteProps> = ({
  label,
  selectedStateCode,
  handleStateChange,
  disabled,
  options,
}) => {
  return (
    <Grid item>
      <Autocomplete
        data-test-id="state"
        id="state-autocomplete"
        options={options}
        disabled={disabled}
        getOptionLabel={(option) => option.value}
        value={options.find((state) => state.key === selectedStateCode) || null}
        onChange={handleStateChange}
        renderInput={(params) => <TextField {...params} label={label} />}
      />
    </Grid>
  );
};

export default StateAutocomplete;
